import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps{
    sx?:SxType
}
const MoveIcon = ({sx={}}:IProps) => {
    return (
        <SvgIcon
            sx={{
                ...sx,
                fill:'#8D8D8F',
                '.darkTheme &':{
                    fill:'#fff',
                }
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
            >
                <mask
                    id="mask0_516_4473"
                    style={{maskType: "alpha"}}
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                >
                    <path  d="M0 0H24V24H0z"></path>
                </mask>
                <g mask="url(#mask0_516_4473)">
                    <path
                        d="M12 22l-4.25-4.25 1.425-1.425L11 18.15V14h2v4.125l1.8-1.825 1.45 1.45L12 22zm-5.75-5.75L2 12l4.225-4.225L7.65 9.2 5.85 11H10v2H5.875L7.7 14.8l-1.45 1.45zm11.5 0l-1.425-1.425L18.15 13H14v-2h4.125L16.3 9.2l1.45-1.45L22 12l-4.25 4.25zM11 10V5.85L9.175 7.675 7.75 6.25 12 2l4.25 4.25-1.425 1.425L13 5.85V10h-2z"
                    ></path>
                </g>
            </svg>
        </SvgIcon>
    );
};

export default MoveIcon;